import http from '../_http'

const detect = {
  //default
  summaryDetect: (m) => { return http.post(`manager/wsfinder/detect/summary`, m); },
  listDetect: (m) => { return http.post(`manager/wsfinder/detect/list`, m); },
  detailDetect: (m) => { return http.get(`manager/wsfinder/detect/${m.id}`); },

  //crud
  insertDetect: (m) => { return http.post(`manager/wsfinder/detect`, m); },
  deleteDetect: (m) => { return http.delete(`manager/wsfinder/detect/${m.id}`); },
}

export default detect

export { detect }